import React from 'react'

import { Box as AlliumBox } from '@telus-uds/components-web'

import { mapDataAttrsToDataSet } from '../../../utils/dataAttributes'
const SPACING_LEVELS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const

export type BoxProps = {
  children?: React.ReactNode
  background?: 'lightest' | 'light' | 'dark' | 'darkest' | 'critical' | 'danger' | 'warning' | 'positive' | 'brand' | ''

  spaceXS?: (typeof SPACING_LEVELS)[number]
  spaceSM?: (typeof SPACING_LEVELS)[number]
  spaceMD?: (typeof SPACING_LEVELS)[number]
  spaceLG?: (typeof SPACING_LEVELS)[number]
  spaceXL?: (typeof SPACING_LEVELS)[number]

  topXS?: (typeof SPACING_LEVELS)[number]
  topSM?: (typeof SPACING_LEVELS)[number]
  topMD?: (typeof SPACING_LEVELS)[number]
  topLG?: (typeof SPACING_LEVELS)[number]
  topXL?: (typeof SPACING_LEVELS)[number]

  bottomXS?: (typeof SPACING_LEVELS)[number]
  bottomSM?: (typeof SPACING_LEVELS)[number]
  bottomMD?: (typeof SPACING_LEVELS)[number]
  bottomLG?: (typeof SPACING_LEVELS)[number]
  bottomXL?: (typeof SPACING_LEVELS)[number]

  leftXS?: (typeof SPACING_LEVELS)[number]
  leftSM?: (typeof SPACING_LEVELS)[number]
  leftMD?: (typeof SPACING_LEVELS)[number]
  leftLG?: (typeof SPACING_LEVELS)[number]
  leftXL?: (typeof SPACING_LEVELS)[number]

  rightXS?: (typeof SPACING_LEVELS)[number]
  rightSM?: (typeof SPACING_LEVELS)[number]
  rightMD?: (typeof SPACING_LEVELS)[number]
  rightLG?: (typeof SPACING_LEVELS)[number]
  rightXL?: (typeof SPACING_LEVELS)[number]

  horizontalXS?: (typeof SPACING_LEVELS)[number]
  horizontalSM?: (typeof SPACING_LEVELS)[number]
  horizontalMD?: (typeof SPACING_LEVELS)[number]
  horizontalLG?: (typeof SPACING_LEVELS)[number]
  horizontalXL?: (typeof SPACING_LEVELS)[number]

  verticalXS?: (typeof SPACING_LEVELS)[number]
  verticalSM?: (typeof SPACING_LEVELS)[number]
  verticalMD?: (typeof SPACING_LEVELS)[number]
  verticalLG?: (typeof SPACING_LEVELS)[number]
  verticalXL?: (typeof SPACING_LEVELS)[number]

  scroll?: boolean
}

const Box = ({
  children,
  background = 'lightest',
  spaceXS,
  spaceSM,
  spaceMD,
  spaceLG,
  spaceXL,
  topXS,
  topSM,
  topMD,
  topLG,
  topXL,
  bottomXS,
  bottomSM,
  bottomMD,
  bottomLG,
  bottomXL,
  leftXS,
  leftSM,
  leftMD,
  leftLG,
  leftXL,
  rightXS,
  rightSM,
  rightMD,
  rightLG,
  rightXL,
  verticalXS,
  verticalSM,
  verticalMD,
  verticalLG,
  verticalXL,
  horizontalXS,
  horizontalSM,
  horizontalMD,
  horizontalLG,
  horizontalXL,
  scroll,
  ...rest
}: BoxProps) => {
  return (
    <AlliumBox
      variant={{ background: background.toLowerCase() }}
      space={{
        xs: spaceXS,
        sm: spaceSM,
        md: spaceMD,
        lg: spaceLG,
        xl: spaceXL,
      }}
      top={{
        xs: topXS,
        sm: topSM,
        md: topMD,
        lg: topLG,
        xl: topXL,
      }}
      bottom={{
        xs: bottomXS,
        sm: bottomSM,
        md: bottomMD,
        lg: bottomLG,
        xl: bottomXL,
      }}
      left={{
        xs: leftXS,
        sm: leftSM,
        md: leftMD,
        lg: leftLG,
        xl: leftXL,
      }}
      right={{
        xs: rightXS,
        sm: rightSM,
        md: rightMD,
        lg: rightLG,
        xl: rightXL,
      }}
      vertical={{
        xs: verticalXS,
        sm: verticalSM,
        md: verticalMD,
        lg: verticalLG,
        xl: verticalXL,
      }}
      horizontal={{
        xs: horizontalXS,
        sm: horizontalSM,
        md: horizontalMD,
        lg: horizontalLG,
        xl: horizontalXL,
      }}
      scroll={scroll}
      testID={'allium-box-testid'}
      dataSet={mapDataAttrsToDataSet(rest)}
    >
      {children}
    </AlliumBox>
  )
}

export default Box
